import React from "react";
import { BaseEdge, EdgeLabelRenderer } from "@xyflow/react";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { getFlowEdgePath, getFlowEdgeStyle } from "./flowEdgeStyle";

/**
 * Custom edge: arrow at target (via markerEnd url from React Flow), delete when selected.
 */
export function DeletableEdge({
  id,
  selected,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  markerEnd,
  markerStart,
  style,
}) {
  const [edgePath, labelX, labelY] = getFlowEdgePath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  const onDelete = data?.onDelete;
  const edgeStyle = getFlowEdgeStyle(selected);

  const handleDelete = (e) => {
    e.stopPropagation();
    if (typeof onDelete === "function") {
      onDelete(id);
    }
  };

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerStart={markerStart}
        markerEnd={markerEnd}
        style={{ ...edgeStyle, ...style }}
        interactionWidth={14}
      />
      {selected && onDelete && (
        <EdgeLabelRenderer>
          <div
            className="nodrag nopan"
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: "all",
              zIndex: 1000,
            }}
          >
            <button
              type="button"
              onClick={handleDelete}
              onMouseDown={(e) => e.stopPropagation()}
              title="Remove connection"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 28,
                height: 28,
                padding: 0,
                border: "1px solid #e0e0e0",
                borderRadius: "50%",
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                cursor: "pointer",
                color: "#d32f2f",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#ffebee";
                e.currentTarget.style.color = "#b71c1c";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
                e.currentTarget.style.color = "#d32f2f";
              }}
            >
              <DeleteIcon sx={{ fontSize: 18 }} />
            </button>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
